module.exports = __webpack_public_path__ + "img/index6.0d1c7f53.png";